import { QueryClient } from '@tanstack/react-query';

export interface PrefetchConfig {
  queryKey: (string | number)[];
  queryFn: () => Promise<any>;
  staleTime?: number;
  cacheTime?: number;
}

/**
 * Creates a prefetch function for a given query configuration
 * @param queryClient - The React Query client instance
 * @param config - Query configuration object
 * @returns A prefetch function that can be called on demand
 */
export const createPrefetchHandler = (
  queryClient: QueryClient, 
  config: PrefetchConfig
) => {
  return () => {
    queryClient.prefetchQuery({
      queryKey: config.queryKey,
      queryFn: config.queryFn,
      staleTime: config.staleTime || 60000, // Default 1 minute
    });
  };
};